import React from 'react';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
}

const Loader: React.FC<LoaderProps> = ({ 
  size = 'medium',
  message
}) => {
  const getSizeAndStyle = () => {
    switch (size) {
      case 'small':
        return { 
          className: 'h-8 w-8',
          style: { border: '2px solid transparent', borderTopColor: 'var(--snaiColor)' }
        };
      case 'medium':
        return { 
          className: 'h-12 w-12',
          style: { border: '3px solid transparent', borderTopColor: 'var(--snaiColor)' }
        };
      default:
        return { 
          className: 'h-16 w-16',
          style: { border: '4px solid transparent', borderTopColor: 'var(--snaiColor)' }
        };
    }
  };

  const { className, style } = getSizeAndStyle();

  return (
    <div className="flex flex-col items-center space-y-4 relative z-40">
      <div className={`animate-spin rounded-full ${className}`}
           style={style}>
      </div>
      
      {message && (
        <p className="text-white text-lg font-medium text-center px-4">
          {message}
        </p>
      )}
    </div>
  );
};

export default Loader;